import Reveal from "@/components/7fcc/Reveal";
import SectionHeader from "@/components/7fcc/SectionHeader";
import CTAButton from "@/components/7fcc/CTAButton";
import { HOME } from "@/data/homeContent";
import { scrollToId } from "@/lib/scroll";

export default function TracksSection() {
  const t = HOME.tracks;
  return (
    <section id="tracks" className="bg-ink-950 px-6 py-16 md:py-24" data-testid="home-tracks">
      <div className="mx-auto max-w-5xl">
        <SectionHeader center eyebrow={t.eyebrow} title={t.headline} support={t.support} testId="home-tracks-heading" />
        <div className="mt-12 grid gap-5 md:mt-16 md:grid-cols-2">
          {t.tracks.map((track, i) => (
            <Reveal key={track.title} delay={i * 0.1} className="h-full">
              <div className="flex h-full flex-col rounded-lg border border-line bg-ink-900/60 p-7 md:p-8" data-testid={`home-track-${i + 1}`}>
                <span className="text-[11px] font-semibold uppercase tracking-[0.24em] text-brand-light">
                  {track.label}
                </span>
                <h3 className="mt-3 font-display text-2xl font-medium text-fg md:text-3xl">{track.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-fg-muted md:text-base">{track.body}</p>
                <ul className="mt-6 flex-1 space-y-3">
                  {track.bullets.map((bullet) => (
                    <li key={bullet} className="flex items-start gap-3 text-sm text-fg-muted">
                      <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-brand" aria-hidden="true" />
                      {bullet}
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <CTAButton
                    label={track.cta.label}
                    targetId={track.cta.anchor}
                    variant="ghost"
                    testId={`home-track-cta-${i + 1}`}
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}